import React, {ChangeEvent, FC} from 'react';

import {Input} from '@optimaxdev/design-system';
import {ActionCreatorWithPayload} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {getValidatedItems} from 'desktop/pages/success/store/selectors/orderItems/orderItems';
import {DoctorDetailsAndUploadValidatedType} from 'desktop/pages/success/types/orderItemsTypes';
import {ApplicationStoreType} from 'desktop/store';
import {DoctorDetailsType, FieldType} from 'types/successPage';

import {AutocompleteDrDetails} from '../autocompleteDrDetails/autocompleteDrDetails';

import s from '../drDetailsRedesign.scss';

export type AutoCompleteMethodType = {
    isModalOpen: boolean | null;
    validatedItems?: DoctorDetailsType;
    doctorDetails: DoctorDetailsType;
    onDoctorDetailsChange: ({target}: ChangeEvent<HTMLInputElement>) => void;
    orderItemId: string;
    changeField: ActionCreatorWithPayload<FieldType, string>;
    setErrors: ActionCreatorWithPayload<DoctorDetailsAndUploadValidatedType, string>;
    selectedSuggestionId: string | null;
    setSelectedSuggestionId: (id: string | null) => void;
    toggleAutocomplete: () => void;
};

/**
 * Container for AutoCompleteMethod dr details
 */
export const AutoCompleteMethod: FC<AutoCompleteMethodType> = ({
    changeField,
    doctorDetails,
    isModalOpen,
    onDoctorDetailsChange,
    orderItemId,
    selectedSuggestionId,
    setErrors,
    setSelectedSuggestionId,
    toggleAutocomplete,
    validatedItems,
}) => {
    return (
        <>
            <div className={s.input}>
                <Input
                    ariaLabel="Patient Name"
                    isError={Boolean(validatedItems?.patientName)}
                    label="Patient Name"
                    name="patientName"
                    onChange={onDoctorDetailsChange}
                    value={doctorDetails.patientName}
                />
            </div>
            <AutocompleteDrDetails
                changeField={changeField}
                doctorDetails={doctorDetails}
                error={validatedItems?.firstName || ''}
                isModalOpen={isModalOpen}
                orderItemId={orderItemId}
                selectedSuggestionId={selectedSuggestionId}
                setErrors={setErrors}
                setSelectedSuggestionId={setSelectedSuggestionId}
                toggleAutocomplete={toggleAutocomplete}
            />
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @param {string} orderItemId - order item id
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType, {orderItemId}: {orderItemId: string}) => ({
    validatedItems: getValidatedItems(store)[orderItemId] as DoctorDetailsType,
});
export const AutoCompleteMethodConnected = connect(mapStateToProps)(AutoCompleteMethod);
